import React from "react";
import "./ArchFooter.scss";

const ArchFooter = ({ logoSrc, altText = "Logo", zIndex, bottom, left, position }) => {
  return (
    <footer className="app-footer" style={{position: position, zIndex: zIndex,  bottom: bottom, left: left}}>
      <div className="footer-content">
        {logoSrc && <img src={logoSrc} alt={altText} className="footer-logo" />}
      </div>
    </footer>
  );
};

export default ArchFooter;
